export default "__VITE_ASSET__Je1RiHl7__"